import { defineMessages } from "react-intl";

import { node as covidDisease } from "src/modules/ktx/forms/transplantation-screening/medical-history/covid/covidDisease";
import { node as covidVaccination } from "src/modules/ktx/forms/transplantation-screening/medical-history/covid/covidVaccination";
import { ParentNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	title: {
		id: "ktx.covid",
		defaultMessage: "COVID"
	}
});

export const node: ParentNode = {
	id: "ktx-covid",
	value: { type: "wizard", title: messages.title },
	children: [covidDisease, covidVaccination]
};
